import { useState, useEffect, useRef } from "react";
import { X, Trash2, Check, FileDown } from "lucide-react";
import { API_BASE } from "../../lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { cn } from "../../lib/utils";

export default function TaskHeader({ task, patch, deleteTask, onClose }) {
  const [title, setTitle] = useState(task.title);
  const savedTitle = useRef(task.title);

  useEffect(() => {
    setTitle(task.title);
    savedTitle.current = task.title;
    // Only re-sync when switching tasks; depending on task.title here would clobber in-progress typing on every server echo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task.id]);

  const commit = () => {
    const t = title.trim();
    if (t && t !== savedTitle.current) {
      savedTitle.current = t;
      patch({ title: t });
    }
  };

  return (
    <div className="flex items-center gap-2 h-12 px-4 border-b border-border shrink-0">
      <button data-testid="panel-toggle-done" onClick={() => patch({ status: task.status === "done" ? "todo" : "done" })}
        className={cn("h-5 w-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors",
          task.status === "done" ? "bg-[#10B981] border-[#10B981] text-white" : "border-muted-foreground/50 hover:border-[#10B981]")}>
        {task.status === "done" && <Check size={12} strokeWidth={3} />}
      </button>
      <input data-testid="panel-title-input" value={title}
        onChange={(e) => setTitle(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
        className="flex-1 font-heading font-bold text-base bg-transparent focus-visible:outline-none min-w-0" />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button data-testid="panel-export-menu" title="Export task"
            className="h-7 w-7 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors">
            <FileDown size={15} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-44">
          <DropdownMenuItem data-testid="panel-export-pdf" asChild>
            <a href={`${API_BASE}/tasks/${task.id}/export?format=pdf`} download>Export as PDF</a>
          </DropdownMenuItem>
          <DropdownMenuItem data-testid="panel-export-excel" asChild>
            <a href={`${API_BASE}/tasks/${task.id}/export?format=xlsx`} download>Export as Excel</a>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <button data-testid="panel-delete-task" onClick={deleteTask} className="h-7 w-7 flex items-center justify-center rounded-md text-muted-foreground hover:text-[#E31E24] hover:bg-[#E31E24]/10 transition-colors">
        <Trash2 size={15} />
      </button>
      <button data-testid="panel-close" onClick={onClose} className="h-7 w-7 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors">
        <X size={16} />
      </button>
    </div>
  );
}
